//
//
//
//
//
//

export default {
    components: {
        UsersGroupsTabs: () => import("@/components/Admin/RolesAndUsers/RolesAndUsersTable/users-groups-tabs")
    },
    props: {
    },
    data() {
        return {
        };
    },
    computed: {
    },
    methods: {
    }
};
